import {makeFormDataPost, makeGet, makePost} from "../Functions";
import {FetchEvents, RequestGroup} from "../RequestGroup";
import DeliveryAddress from "../jtmc/models/DeliveryAddress";
import {OverviewData} from "../jtmc/models/OverviewData";
import Order from "../jtmc/models/Order";
import OrderAndOverviewData from "../jtmc/models/OrderAndOverviewData";
import {OrderType} from "../../types";
import DiscountCodeResponse from "../jtmc/models/DiscountCodeResponse";
import OrderAction from "../jtmc/models/OrderAction";
import IPGLinkResponse from "../jtmc/models/IPGLinkResponse";

export class OrderFunctions extends RequestGroup {
    branchId = 0;
    tableId = 0;
    orderType:OrderType = "table";
    constructor(props: {defaultEvents:any, branchId:number, orderType: OrderType, tableId: number}) {
        super({
            defaultEvents: props.defaultEvents
        });
        this.branchId = props.branchId;
        this.orderType = props.orderType;
        this.tableId = props.tableId;
    }
    requests = {
        addOrEditAddress: (data: {
            id: number | null,
            name: string,
            title: string,
            address: string,
            phone: string,
            latlong: string
        }) => {
            return this.customPromise((events: FetchEvents) => {
                makePost(`/menu/${this.branchId}/${this.orderType}/${this.tableId}/address/addOrEdit`,
                    data,
                    null,
                    events,
                    true);
            }, {class: DeliveryAddress, isArray: false})
        },
        // Todo: Move the map, setup new page no list, add button, adding page, adding map and other stuf
        // Be fast
        getAddresses: () => {
            return this.customPromise((events: FetchEvents) => {
                makeGet(`/menu/${this.branchId}/${this.orderType}/${this.tableId}/address/get`,
                    null,
                    events,
                    true);
            }, {class: DeliveryAddress, isArray: true})
        },
        getFinalizationData: () => {
            return this.customPromise((events: FetchEvents) => {
                makeGet(`/menu/${this.branchId}/${this.orderType}/${this.tableId}/order/finalization/data`,
                    null,
                    events,
                    true);
            }, {class: OverviewData, isArray: false})
        },
        setAddress: (data: {
            id: number | null,
        }) => {
            return this.customPromise((events: FetchEvents) => {
                makePost(`/menu/${this.branchId}/${this.orderType}/${this.tableId}/address/set`,
                    data,
                    null,
                    events,
                    true);
            }, {class: Order, isArray: false})
        },
        setPaymentMethod: (data: {
            method: string,
        }) => {
            return this.customPromise((events: FetchEvents) => {
                makePost(`/menu/${this.branchId}/${this.orderType}/${this.tableId}/payment-method/set`,
                    data,
                    null,
                    events,
                    true);
            }, {class: OrderAndOverviewData, isArray: false})
        },
        setDeliveryMethod: (data: {
            method: string,
        }) => {
            return this.customPromise((events: FetchEvents) => {
                makePost(`/menu/${this.branchId}/${this.orderType}/${this.tableId}/delivery-type/set`,
                    data,
                    null,
                    events,
                    true);
            }, {class: OrderAndOverviewData, isArray: false})
        },
        setDiscountCode: (data: {
            code: string
        }) => {
            return this.customPromise((events: FetchEvents) => {
                makePost(`/menu/${this.branchId}/${this.orderType}/${this.tableId}/discount-code/set`,
                    data,
                    null,
                    events,
                    true);
            }, {class: DiscountCodeResponse, isArray: false})
        },

        performItems: (data: any) => {
            return this.customPromise((events: FetchEvents, onReject: any) => {
                makePost(`/menu/${this.branchId}/${this.orderType}/${this.tableId}/items/perform`,
                    data,
                    null, events, true);
            }, {class: Order, isArray: false})
        },
        finalize: (data: {
            description: string,
            payment_method: string
        }) => {
            return this.customPromise((events: FetchEvents, onReject: any) => {
                makePost(`/menu/${this.branchId}/${this.orderType}/${this.tableId}/finalize`,
                    data,
                    null, events, true);
            }, {class: OrderAction, isArray: false})
        },
        getIPGLink: () => {
            return this.customPromise((events: FetchEvents, onReject: any) => {
                makeGet(`/menu/${this.branchId}/${this.orderType}/${this.tableId}/ipg/get`,
                    {},
                    events, true);
            }, {class: IPGLinkResponse, isArray: false})
        },
        ctcPaymentConfirm: (receipt: any) => {
            return this.customPromise((events: FetchEvents, onReject: any) => {
                makeFormDataPost(`/menu/${this.branchId}/${this.orderType}/${this.tableId}/ctc/receipt`,
                    {},
                    [{
                        file: receipt,
                        name: "receipt_shot"
                    }],
                    {},
                    events, true);
            }, {class: Order, isArray: false})
        },
        cancel: () => {
            return this.customPromise((events: FetchEvents, onReject: any) => {
                makeGet(`/menu/${this.branchId}/${this.orderType}/${this.tableId}/cancel`,
                    {},
                    events,
                    true);
            }, {class: Order, isArray: false})
        }
    }
}